import { ApmVuePlugin } from '@elastic/apm-rum-vue'

import pkg from '~/../package.json'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(ApmVuePlugin, {
    router: nuxtApp.$router,
    config: {
      serverUrl: window.location.protocol + '//' + window.location.host,
      serviceName: 'Web_Frontend_Prize',
      serverUrlPrefix: '/front/api/apm/events',
      serviceVersion: pkg.version,
      environment: window.location.host,
      active: true,
      monitorLongtasks: true,
      sendCredentials: true,
      usePathAsTransactionName: true,
      transactionSampleRate: 0.3,
    },
  })

  return {
    provide: {
      apm: nuxtApp.vueApp.config.globalProperties.$apm,
    },
  }
})
